import { RestUrl } from "../common/cyan.types";

export class PapyrusServiceInspectUrl {
  public static inspect: RestUrl = ["GET", "/internal/inspect"];
}
